/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Preview_StartInputs */

const en_highlight_settings_preview_start = /** @type {(inputs: Highlight_Settings_Preview_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is a`)
};

const es_highlight_settings_preview_start = /** @type {(inputs: Highlight_Settings_Preview_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es una`)
};

/**
* | output |
* | --- |
* | "This is a" |
*
* @param {Highlight_Settings_Preview_StartInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_preview_start = /** @type {((inputs?: Highlight_Settings_Preview_StartInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Preview_StartInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_preview_start(inputs)
	return en_highlight_settings_preview_start(inputs)
});